import { forwardRef } from "react";

import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from '@mui/icons-material/Pause';
import ReplayIcon from '@mui/icons-material/Replay';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';

import styles from "./index.module.css";
import control from "../index.module.css";
import { IconButton } from "@mui/material";

const MobileControls = forwardRef((props, ref) => {

    const {
        next,
        prev,
        playing,
        currentTime,
        endTime,
        onPlayingToggle = () => {},
        onPrev = () => {},
        onNext = () => {},
        safari
    } = props;

    if (!navigator?.userAgentData?.mobile) return null;
    return (
        <div className={`${control.mobileControls} ${styles.container}`} hidden={safari}>
            <div>

            </div>
            <div>
                <IconButton 
                    onClick={onPrev}
                    style={{ color: prev ? "white" : "" }}
                    disabled={!prev}
                    className={control.buttons}
                >
                    <SkipPreviousIcon/>
                </IconButton>
                <IconButton
                    onClick={onPlayingToggle}
                    className={`${styles.playButton} ${control.buttons}`}
                >
                    {(() => {
                        if (currentTime != endTime) {
                            if (playing) return <PauseIcon/>;
                            else return <PlayArrowIcon/>;
                        }
                        else return <ReplayIcon/>;
                    })()}
                </IconButton>
                <IconButton
                    onClick={onNext}
                    style={{ color: next ? "white" : "" }}
                    disabled={!next}
                    className={control.buttons}
                >
                    <SkipNextIcon/>
                </IconButton>
            </div>
        </div>
    );
});

export default MobileControls;